var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7857 9.71429H9.71429V15.7857C9.71429 16.1078 9.58635 16.4166 9.35863 16.6443C9.13091 16.8721 8.82205 17 8.5 17C8.17795 17 7.86909 16.8721 7.64137 16.6443C7.41365 16.4166 7.28571 16.1078 7.28571 15.7857V9.71429H1.21429C0.892237 9.71429 0.583379 9.58635 0.355656 9.35863C0.127934 9.13091 0 8.82205 0 8.5C0 8.17795 0.127934 7.86909 0.355656 7.64137C0.583379 7.41365 0.892237 7.28572 1.21429 7.28572H7.28571V1.21429C7.28571 0.892237 7.41365 0.583378 7.64137 0.355656C7.86909 0.127933 8.17795 0 8.5 0C8.82205 0 9.13091 0.127933 9.35863 0.355656C9.58635 0.583378 9.71429 0.892237 9.71429 1.21429V7.28572H15.7857C16.1078 7.28572 16.4166 7.41365 16.6443 7.64137C16.8721 7.86909 17 8.17795 17 8.5C17 8.82205 16.8721 9.13091 16.6443 9.35863C16.4166 9.58635 16.1078 9.71429 15.7857 9.71429Z",
    fill: "#03212B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1a30345b7816f277fff92f70eb416224.svg";
export { ForwardRef as ReactComponent };